import { atom } from 'jotai';
import { StoredUser } from '@shared/types';

// after first auth check has value StoretUser | null
export const userAtom = atom<StoredUser | null | undefined>(undefined);

export const userLoginModalOpenAtom = atom<boolean>(false);

export const userProfileModalOpenAtom = atom<boolean>(false);
